module.exports = __webpack_public_path__ + "img/breakfast.6a59f08a.svg";